import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    standalone: false
})
export class ErrorComponent {
  @Input() code: string;
  @Input() description: string;
  @Input() icon: string;
  @Input() css_class: string;
}
